function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M8.478 15H1.773A.773.773 0 011 14.227V1.773C1 1.346 1.346 1 1.773 1h12.454c.427 0 .773.346.773.773v12.454a.773.773 0 01-.773.773H10.66V9.578h1.82l.272-2.112H10.66v-1.35c0-.611.17-1.028 1.047-1.028h1.119v-1.89a14.957 14.957 0 00-1.63-.084c-1.614 0-2.718.985-2.718 2.793v1.559H6.653v2.112h1.825V15z"
});

var SvgIcFb = function SvgIcFb(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/ic-fb.749d8d2c.svg";
export { SvgIcFb as ReactComponent };